import {FC} from 'react'
import {FieldArray} from 'formik'
import {CFields, FieldProps} from './Form'
import {KTSVG} from '../_metronic/helpers'
import {useAuth} from '../app/modules/auth'
import {useTenantT} from '../i18n'

export type MultiInputProps = {
  name: string
  label?: string
  fields: FieldProps[]
}

export const MultiInput: FC<{field: MultiInputProps; formik: any}> = ({field, formik}) => {
  const t = useTenantT()
  const {currentUser} = useAuth()
  const {name, fields, label} = field

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div className='mb-5'>
          <span
            className='svg-icon btn-icon svg-icon-2 cursor-pointer ml-2'
            onClick={() => arrayHelpers.push({})}
          >
            <label className={'form-label mb-3 '}>{t(label || '')}</label>
            <KTSVG
              path='/media/icons/duotune/general/gen041.svg'
              className='svg-icon-primary svg-icon-1hx'
            />
          </span>

          {formik.values[field.name]?.map((item: any, idx: number) =>
            item.deleted ? null : (
              <div className='row mb-3 border rounded-3 py-2' key={idx}>
                {fields.map((f, idx2) =>
                  currentUser?.role_id === 4 &&
                  ['class_id', 'section_id', 'student_id'].includes(field.name) ? null : (
                    <CFields
                      key={idx + '_' + idx2}
                      field={{...f, name: `${name}[${idx}].${f.name}`}}
                      formik={formik}
                      idx={idx}
                    />
                  )
                )}
                <div className='mb-6 fv-row col-lg-6'>
                  <button
                    type='button'
                    className='btn btn-sm btn-danger'
                    onClick={() => {
                      if (item.id) {
                        formik.setFieldValue(`${name}[${idx}].deleted`, true) // Mark as deleted instead of removing from the array
                      } else arrayHelpers.remove(idx)
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )
          )}
        </div>
      )}
    />
  )
}
